import { motion } from 'motion/react';
import { Clock, Leaf, Shield, Snowflake, Sparkles, type LucideIcon } from 'lucide-react';
import { GlassCard } from '@/components/shared/GlassCard';
import { fadeUp, inViewOnce, staggerContainer } from '@/lib/motion/variants';

type Trust = { icon: LucideIcon; title: string; sub: string };

const ITEMS: Trust[] = [
  { icon: Shield, title: 'Verified guides', sub: 'Police-checked' },
  { icon: Snowflake, title: 'Secure payments', sub: 'Razorpay · UPI · Visa' },
  { icon: Clock, title: '24/7 trip support', sub: 'WhatsApp EN+HI+KS' },
  { icon: Leaf, title: 'Local expertise', sub: 'Founded in Srinagar' },
  { icon: Sparkles, title: '500+ experiences', sub: 'New every week' },
];

export function TrustBar() {
  return (
    <section className="mx-auto mt-20 max-w-7xl px-4 md:px-6">
      <GlassCard className="p-6 md:p-7">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={inViewOnce}
          variants={staggerContainer}
          className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5"
        >
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <motion.div key={it.title} variants={fadeUp} className="flex items-start gap-3">
                <div
                  className="grid h-10 w-10 shrink-0 place-items-center rounded-[12px]"
                  style={{
                    background: 'rgba(46, 170, 138, 0.14)',
                    border: '1px solid rgba(46, 170, 138, 0.4)',
                  }}
                >
                  <Icon size={17} className="text-[var(--color-teal)]" />
                </div>
                <div>
                  <div className="text-[13px] font-semibold text-ink">{it.title}</div>
                  <div className="mt-0.5 text-[11px] text-ink-dim">{it.sub}</div>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </GlassCard>
    </section>
  );
}
